<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { isValidPassword } from 'shared/helpers/Validators';
const password = defineModel('password', { type: String, default: '' });
const confirmation = defineModel('confirmation', { type: String, default: '' });
const { t } = useI18n();
const visible = ref(false);
const invalidPassword = computed(
  () =>
    password.value.length > 0 &&
    (password.value.length < 6 ||
      password.value.length > 128 ||
      !isValidPassword(password.value))
);
const mismatch = computed(
  () => confirmation.value.length > 0 && confirmation.value !== password.value
);
</script>

<template>
  <div class="w-full space-y-3" data-testid="master-password-fields">
    <label class="block" :class="{ error: invalidPassword }">
      {{ t('AGENT_PASSWORD.PASSWORD') }}
      <div class="relative">
        <input
          v-model="password"
          :type="visible ? 'text' : 'password'"
          name="new-password"
          autocomplete="new-password"
          required
          minlength="6"
          maxlength="128"
          :aria-invalid="invalidPassword"
          class="!mb-0 !pe-20"
        />
        <button
          type="button"
          class="absolute end-2 top-1/2 -translate-y-1/2 text-xs text-n-slate-11 hover:text-n-slate-12"
          :aria-pressed="visible"
          @click="visible = !visible"
        >
          {{ visible ? t('AGENT_PASSWORD.HIDE') : t('AGENT_PASSWORD.SHOW') }}
        </button>
      </div>
    </label>
    <label class="block" :class="{ error: mismatch }">
      {{ t('AGENT_PASSWORD.CONFIRMATION') }}
      <input
        v-model="confirmation"
        :type="visible ? 'text' : 'password'"
        name="password-confirmation"
        autocomplete="new-password"
        required
        minlength="6"
        maxlength="128"
        :aria-invalid="mismatch"
        class="!mb-0"
      />
    </label>
    <p
      class="!m-0 text-xs text-n-slate-11"
      :class="{ '!text-n-ruby-11': invalidPassword }"
    >
      {{ t('AGENT_PASSWORD.RULE') }}
    </p>
    <p v-if="mismatch" role="alert" class="!m-0 text-xs text-n-ruby-11">
      {{ t('AGENT_PASSWORD.ERRORS.PASSWORD_CONFIRMATION_MISMATCH') }}
    </p>
  </div>
</template>
